// Provider metadata (labels, colors, icons) for chips and charts.
// Positive pre-measurement size; ResizeObserver replaces it with real bounds.
// Matches the existing compact chart height token; avoids Recharts -1 warnings.
export const CHART_INITIAL_DIMENSIONS = Object.freeze({ width: 320, height: 260 });

export const PROVIDERS = {
  openai: {
    key: 'openai',
    label: 'ChatGPT',
    short: 'ChatGPT',
    tone: 'emerald',
    dot: 'bg-emerald-500',
    bg: 'bg-emerald-50',
    text: 'text-emerald-800',
    border: 'border-emerald-200',
    color: '#059669',
  },
  anthropic: {
    key: 'anthropic',
    label: 'Claude',
    short: 'Claude',
    tone: 'orange',
    dot: 'bg-orange-500',
    bg: 'bg-orange-50',
    text: 'text-orange-800',
    border: 'border-orange-200',
    color: '#EA580C',
  },
  gemini: {
    key: 'gemini',
    label: 'Gemini',
    short: 'Gemini',
    tone: 'sky',
    dot: 'bg-sky-500',
    bg: 'bg-sky-50',
    text: 'text-sky-800',
    border: 'border-sky-200',
    color: '#0284C7',
  },
  perplexity: {
    key: 'perplexity',
    label: 'Perplexity',
    short: 'Perplexity',
    tone: 'slate',
    dot: 'bg-slate-400',
    bg: 'bg-slate-50',
    text: 'text-slate-800',
    border: 'border-slate-200',
    color: '#64748B',
  },
  copilot: {
    key: 'copilot',
    label: 'Copilot',
    short: 'Copilot',
    tone: 'indigo',
    dot: 'bg-indigo-400',
    bg: 'bg-indigo-50',
    text: 'text-indigo-800',
    border: 'border-indigo-200',
    color: '#6366F1',
  },
  google_ai_overview: {
    key: 'google_ai_overview',
    label: 'Google AI Overview',
    short: 'Google AIO',
    tone: 'amber',
    dot: 'bg-amber-400',
    bg: 'bg-amber-50',
    text: 'text-amber-900',
    border: 'border-amber-200',
    color: '#D97706',
  },
};

export const LIVE_PROVIDERS = ['openai', 'anthropic', 'gemini'];
export const COMING_SOON = ['perplexity', 'copilot', 'google_ai_overview'];

export const CHART_COLORS = [
  'hsl(186 78% 34%)', // teal (brand)
  'hsl(205 90% 45%)', // blue
  'hsl(152 55% 36%)', // green
  'hsl(38 92% 50%)',  // amber
  'hsl(222 47% 35%)', // ink navy
  'hsl(0 72% 51%)',   // red
  'hsl(280 40% 45%)',
];
